import { render } from "./UserIcon.vue?vue&type=template&id=57a163e2&scoped=true"
const script = {}

import "./UserIcon.vue?vue&type=style&index=0&id=57a163e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a163e2"]])

export default __exports__